var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcWcagAnimation = function SvgIcWcagAnimation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1429.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animacja",
    transform: "translate(1352.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_animacja_pause",
    transform: "translate(77.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2.2,
    cx: 10,
    cy: 10,
    r: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6,5.3 C8.17177715,5.3 8.64166236,5.73625126 8.69496451,6.29406266 L8.7,6.4 L8.7,13.6 C8.7,14.2075132 8.20751322,14.7 7.6,14.7 C7.02822285,14.7 6.55833764,14.2637487 6.50503549,13.7059373 L6.5,13.6 L6.5,6.4 C6.5,5.79248678 6.99248678,5.3 7.6,5.3 Z M12.4,5.3 C12.9717772,5.3 13.4416624,5.73625126 13.4949645,6.29406266 L13.5,6.4 L13.5,13.6 C13.5,14.2075132 13.0075132,14.7 12.4,14.7 C11.8282228,14.7 11.3583376,14.2637487 11.3050355,13.7059373 L11.3,13.6 L11.3,6.4 C11.3,5.79248678 11.7924868,5.3 12.4,5.3 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcWcagAnimation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_wcag_animation.a2ba92ba.svg";
export { ForwardRef as ReactComponent };